module.exports = __webpack_public_path__ + "img/add-ebook.8152a794.svg";